<template>
    <div>-</div>
</template>

<script>
export default {
    name: "the-dash-sign",
};
</script>
